import { render, staticRenderFns } from "./GroupedRowButton.vue?vue&type=template&id=2d2b44f7&scoped=true"
import script from "./GroupedRowButton.vue?vue&type=script&lang=js"
export * from "./GroupedRowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b44f7",
  null
  
)

export default component.exports